import { render, staticRenderFns } from "./PropertyModalItem.vue?vue&type=template&id=34982ff8&scoped=true&"
import script from "./PropertyModalItem.vue?vue&type=script&lang=js&"
export * from "./PropertyModalItem.vue?vue&type=script&lang=js&"
import style0 from "./PropertyModalItem.vue?vue&type=style&index=0&id=34982ff8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34982ff8",
  null
  
)

export default component.exports